import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {TimeTrackerResponse} from 'models';
import {AppRootState} from 'store/appStore';

export interface timeTrackerState {
    counterValueInRedux: number;
    selectedTimeTrackInRedux: TimeTrackerResponse | null;
    timeTrackerInterval: NodeJS.Timeout | null;
    isConuterStarted: boolean;
}

const initialState: timeTrackerState = {
    counterValueInRedux: 0,
    selectedTimeTrackInRedux: null,
    timeTrackerInterval: null,
    isConuterStarted: false,
};

const timeTrackerSlice = createSlice({
    name: 'timeTracker',
    initialState,
    reducers: {
        setCounterValue: (state, action: PayloadAction<number>) => {
            state.counterValueInRedux = action.payload;
        },
        startCounter: state => {
            state.counterValueInRedux += 1;
            state.isConuterStarted = true;
        },
        stopCounter: state => {
            state.isConuterStarted = false;
            if (state.timeTrackerInterval) {
                clearInterval(state.timeTrackerInterval);
            }
            state.timeTrackerInterval = null;
            state.counterValueInRedux = 0;
        },

        setSelectedTimeTracker: (state, action: PayloadAction<TimeTrackerResponse | null>) => {
            state.selectedTimeTrackInRedux = action.payload;
        },
        setTimeTrackerInterval: (state, action: PayloadAction<NodeJS.Timeout | null>) => {
            state.timeTrackerInterval = action.payload;
        },
    },
});

export const {startCounter, setCounterValue, stopCounter, setSelectedTimeTracker, setTimeTrackerInterval} =
    timeTrackerSlice.actions;

export const timeTrackerSliceReducer = timeTrackerSlice.reducer;
export const timeTrackerSelector = (rootState: AppRootState): timeTrackerState => rootState.timeTracker;
